import { useQuery } from '@tanstack/react-query'
import { AnalyticsApi, data } from '@portal/pkg-api/shared'

const prefix = 'shared.analytics'

export const AnalyticsQueries = {
  analytics: () => ({
    queryKey: [`${prefix}.analytics`],
    queryFn: () => data(AnalyticsApi.getAnalyticsConfig({ mercatusNotifyOnError: false })),
  }),
}

export function useAnalytics() {
  return useQuery(AnalyticsQueries.analytics())
}
